export default class ScrollingTiledSprites extends Phaser.Group {
  constructor({ game, spritesheet, tiles, offset, decorations, minHeight, maxHeight, flipTile = false, anchor = { x: 0, y: 0 } }) {
    super(game);

    this.spritesheet = spritesheet;
    this.decorations = decorations;
    this.tiles = tiles;
    this.offset = offset || { x: 0, y: 0 };
    this.minHeight = minHeight;
    this.maxHeight = maxHeight;
    this.tilesActive = [];
    this.tilesPool = [];
    this.decorationPool = [];
    this.tileAnchor = anchor;
    this.flipTile = flipTile;
    this.fillContent(this.maxHeight);
  }

  fillContent(startY) {
    // rab the starting position
    let initY = startY;
    //  we build upward
    while (initY > 0) {
      // generate a random tile
      const tile = this.generateTile();
      // position the tile, offsetting by tileheight
      tile.y = initY + this.offset.y - tile.height;

      tile.x = this.offset.x;

      if (this.flipTile) {
        tile.scale.set(-1, 1);
        tile.x += Math.abs(tile.width);
      }

      // add to active array
      this.tilesActive.push(tile);
      // add to display - force to back layer
      this.addAt(tile, 0);
      // update position
      initY = tile.y;
    }
  }

  generateTile() {
    // grab an pooled tile if possible, else create a new one
    const tile = this.tilesPool.shift() || this.game.make.image();
    // apply random texture
    this.randomlyDecorateSprite(tile, this.tiles);
    // anchor tile to requirements
    tile.anchor.set(this.tileAnchor.x, this.tileAnchor.y);
    // if tile decorations are an option
    if (this.decorations && this.decorations.length > 0 && Math.random() > 0.5) {
      // grab from pool or generate new
      const decorationSprite = this.decorationPool.shift() || this.game.make.image();
      // apply random texture
      this.randomlyDecorateSprite(decorationSprite, this.decorations);
      // position in semi-random oplace on tile
      decorationSprite.y = Math.random() > 0.5 ? tile.height * 0.25 : tile.y * 0.75;

      decorationSprite.x = tile.width * (tile.anchor.x * -1);

      // add decoration to tile
      tile.decoration = decorationSprite;
      tile.addChild(decorationSprite);
    }

    // return result
    return tile;
  }

  randomlyDecorateSprite(sprite, options) {
    const option = options[Math.floor(Math.random() * options.length)];
    sprite.loadTexture(this.spritesheet, option);
    return sprite;
  }

  updateScoll(distance) {
    // track where the top tile lies
    let minY = false;

    // reduce tiles active, taing out any expired tiles
    this.tilesActive = this.tilesActive.reduce((arr, tile) => {
      // increment tile position
      tile.y += distance;
      // if tile is out of view
      if (tile.y > this.maxHeight) {
        // remove and pool tile
        this.clearTile(tile);
      } else {
        // otherwise push back into array for return
        arr.push(tile);
      }
      // update min Y
      if (minY === false || tile.y < minY) {
        minY = tile.y;
      }

      return arr;
    }, []);

    // populate content
    if (minY) {
      this.fillContent(minY);
    }
  }

  clearTile(tile) {
    if (tile.decoration) {
      // clean up tile decoration if it exists
      this.decorationPool.push(tile.decoration);
      tile.removeChild(tile.decoration);
      tile.decoration = false;
    }
    // clean up tile
    this.remove(tile);
    this.tilesPool.push(tile);
  }
}
